import { useEffect, useEffectEvent } from "react";
import { useNavigate } from "react-router";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { DISCOVER } from "../../../constants/routes";
import { useEvents } from "../../../hooks";
import { useMarketSpotlightPageLayout } from "../../../hooks/api/v2/marketSpotlightLayout/useMarketSpotlightPageLayout";
import { useMarketStorefrontSessionId } from "../../../hooks/useMarketStorefrontSessionTracking";
import { SpotlightListCollectionCard } from "../SpotlightListCollection/SpotlightListCollectionCard";

export const ProductSpotlightOverviewPage = () => {
  const navigate = useNavigate();
  const { sessionId } = useMarketStorefrontSessionId();
  const { track } = useEvents();
  const marketSpotlightPageLayoutQuery = useMarketSpotlightPageLayout({
    type: "product",
  });

  const pageIds = marketSpotlightPageLayoutQuery.data?.pageIds;

  const trackPageView = useEffectEvent(() => {
    track("Product Spotlight List Viewed", {
      sessionId,
    });
  });

  useEffect(() => {
    trackPageView();
  }, []);

  if (!pageIds?.length) return null;
  return (
    <>
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={`Product spotlights`}
      />
      <div className="flex items-center justify-center p-4">
        <div className="grid grid-cols-3 gap-4">
          {pageIds.map((pageId, index) => (
            <div key={pageId} className={"col-span-1 gap-4"}>
              <SpotlightListCollectionCard
                pageId={pageId}
                key={index}
                type={"product style"}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
